export default "__VITE_ASSET__Ci3yjxFp__"